import {Main} from './main';
import {GeneralUtility} from './utilities/general-utility';
import {FormHelpers} from './components/form-helpers';
import {LanguageUtility} from './utilities/language-utility';
import mitt from 'mitt';
import {Settings} from './utilities/settings';

// Add a custom, "global" event emitter to the window object. Can be useful in some edge cases, where it would be nice
// to send and receive some data.
window.emitter = mitt<any>();

document.addEventListener('DOMContentLoaded', () => {
  // Setup global resize events
  let orientation = GeneralUtility.getDeviceOrientation();
  document.body.classList.add(orientation);
  let previousOrientation: string = '';

  window.addEventListener('resize', () => {
    GeneralUtility.browserEmitter.emit('resize', GeneralUtility.getWindowDimensions());

    // Update device orientation
    orientation = GeneralUtility.getDeviceOrientation();
    if (orientation !== previousOrientation) {
      if (previousOrientation) {
        document.body.classList.remove(previousOrientation);
      }
      if (orientation) {
        document.body.classList.add(orientation);
        GeneralUtility.browserEmitter.emit('orientation', orientation);
      }
    }

    previousOrientation = orientation;
  }, {capture: false, passive: true});

  // Setup global scroll events
  let previousScrollY = 0;
  let previousScrollX = 0;
  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;
    const scrollX = window.scrollX;
    const scrollPosition = GeneralUtility.getScrollPosition();
    scrollPosition.previousScrollX = previousScrollX;
    scrollPosition.previousScrollY = previousScrollY;
    GeneralUtility.browserEmitter.emit('scroll', scrollPosition);
    previousScrollY = scrollY;
    previousScrollX = scrollX;
  }, {capture: false, passive: true});

  // Check if there are any unsaved forms, before leaving the page
  FormHelpers.initializeUnsavedFormsCheck();
  window.addEventListener('beforeunload', e => {
    if (FormHelpers.checkIfUnsavedFormsPresent()) {
      return LanguageUtility.translate('formsChanged');
    } else {
      return undefined;
    }
  });

  // Initialize app
  new Main();
});

window.addEventListener('beforeunload', () => {
  const now = Math.floor((new Date()).getTime() / 1000);
  const settingsTimestamp = Math.floor(Settings.instance.settings.timestamp / 1000);

  // Reset settings after 1 hour
  if (settingsTimestamp < now - (1 * 60 * 60)) {
    Settings.instance.reset();
  }
});
